import { getGradeStyle } from '@aibees/elephant/utils/grade-config';
import { SearchRelevancyGrade } from '@aibees/shared/definition';
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const circular: SxStyle = {
  position: 'relative',
  display: 'inline-flex',
  cursor: 'pointer',
};

export const column: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(2),
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: (p) => p.spacing(3),
};

export const leftSide: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const grade: SxStyleFunc<{ grade?: SearchRelevancyGrade }> =
  ({ grade: gradeDraft }) =>
  (theme) => {
    const { color, fontWeight } = getGradeStyle(theme, gradeDraft);
    return {
      color,
      fontSize: theme.typography.caption,
      fontWeight,
    };
  };

export const circularBorder: SxStyleFunc<{ grade?: SearchRelevancyGrade }> =
  ({ grade: gradeDraft }) =>
  (theme) => {
    const { borderColor, stroke } = getGradeStyle(theme, gradeDraft);
    return {
      borderColor,
      stroke,
    };
  };
